var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound52BSelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M44.77 21.148a2.506 2.506 0 0 1-3.074-1.764L38.849 8.758a2.506 2.506 0 0 1 1.78-3.065l9.707-2.6c1.34-.36 2.717.43 3.074 1.764l2.847 10.625a2.506 2.506 0 0 1-1.78 3.065l-9.707 2.601Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M46.227 20.757a1.002 1.002 0 0 1 .712-1.226l7.28-1.95a1.504 1.504 0 0 0 1.069-1.84L52.44 5.116a1.504 1.504 0 0 0-1.845-1.059l-7.28 1.951a1.003 1.003 0 0 1-1.23-.706 1.003 1.003 0 0 1 .712-1.226l7.28-1.95a3.509 3.509 0 0 1 4.304 2.47L57.23 15.22a3.509 3.509 0 0 1-2.492 4.291l-7.28 1.951a1.003 1.003 0 0 1-1.23-.706Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M40.617 54.304a2.5 2.5 0 0 1-1.768-3.062l2.847-10.625a2.5 2.5 0 0 1 3.062-1.768l9.659 2.588a2.5 2.5 0 0 1 1.768 3.062l-2.847 10.625a2.5 2.5 0 0 1-3.062 1.768l-9.66-2.588Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M42.066 54.692a1 1 0 0 1 1.225-.707l7.245 1.941a1.5 1.5 0 0 0 1.837-1.06L55.22 44.24a1.5 1.5 0 0 0-1.06-1.837l-7.245-1.94a1 1 0 1 1 .517-1.933l7.245 1.941a3.5 3.5 0 0 1 2.475 4.287l-2.847 10.625a3.5 3.5 0 0 1-4.287 2.475l-7.245-1.941a1 1 0 0 1-.707-1.225Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M16.5 39.334a2.5 2.5 0 0 1 2.5 2.5V53.5a2.5 2.5 0 0 1-2.5 2.5h-10A2.5 2.5 0 0 1 4 53.5V39.334h12.5ZM16.5 21.666a2.5 2.5 0 0 1 2.5 2.5v11.667a2.5 2.5 0 0 1-2.5 2.5H4V21.667h12.5ZM16.5 4A2.5 2.5 0 0 1 19 6.5v11.667a2.5 2.5 0 0 1-2.5 2.5H4V6.5A2.5 2.5 0 0 1 6.5 4h10Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M15 56a1 1 0 0 1-1 1H6.5A3.5 3.5 0 0 1 3 53.5v-47A3.5 3.5 0 0 1 6.5 3H14a1 1 0 1 1 0 2H6.5A1.5 1.5 0 0 0 5 6.5v47A1.5 1.5 0 0 0 6.5 55H14a1 1 0 0 1 1 1Z",
  clipRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 40,
  r: 6,
  fill: "#464D57",
  stroke: "#C1A36E",
  strokeWidth: 2,
  transform: "rotate(-90 30 40)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 20,
  r: 6,
  fill: "#464D57",
  stroke: "#C1A36E",
  strokeWidth: 2,
  transform: "rotate(-90 30 20)"
})));
SvgRound52BSelected.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound52BSelected);
export default ForwardRef;